module.exports = __webpack_public_path__ + "static/media/tooltip_referral.f662b4ab.svg";